<template>
  <div class="login-page">
    <div class="login-shell">
      <div class="login-card">
        <div class="login-brandbar">
          <div class="login-brand">
            <LuckLogo />
            <span class="login-brand-divider"></span>
            <img
              class="login-brand-nexia"
              src="@/assets/nexia-logo-dark.png"
              alt="Nexia"
            />
          </div>
        </div>

        <form class="login-body" @submit.prevent="submit">
          <h1 class="login-title">Monitoramento de Agentes</h1>

          <div class="login-field">
            <label class="login-label" for="email">E-mail</label>
            <input
              id="email"
              v-model.trim="email"
              type="email"
              class="login-input"
              autocomplete="username"
              placeholder="voce@empresa.com"
              :disabled="loading"
              required
            />
          </div>

          <div class="login-field">
            <label class="login-label" for="senha">Senha</label>
            <input
              id="senha"
              v-model="password"
              type="password"
              class="login-input"
              autocomplete="current-password"
              placeholder="••••••••"
              :disabled="loading"
              required
            />
          </div>

          <!-- role=alert para leitores de tela anunciarem a falha -->
          <p v-if="erro" class="login-error" role="alert">
            <v-icon size="15" color="#c81e22">mdi-alert-circle-outline</v-icon>
            {{ erro }}
          </p>

          <button class="login-button" type="submit" :disabled="loading">
            <v-icon v-if="loading" size="17" class="login-spin"
              >mdi-loading</v-icon
            >
            {{ loading ? "Entrando..." : "Entrar" }}
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import LuckLogo from "@/components/LuckLogo/LuckLogo.vue";
import { login } from "@/services/nexiaApi";

export default {
  name: "LoginView",
  components: { LuckLogo },
  data() {
    return { email: "", password: "", erro: "", loading: false };
  },
  methods: {
    async submit() {
      this.erro = "";
      this.loading = true;
      try {
        const user = await login(this.email, this.password);
        this.$emit("authenticated", user);
      } catch (e) {
        // A API devolve mensagem unica para e-mail inexistente e senha errada,
        // para nao permitir descobrir quais contas existem.
        this.erro =
          e?.response?.data?.error ||
          "Nao foi possivel entrar. Tente novamente.";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./styles.scss";
</style>
